import { render, staticRenderFns } from "./NInputSuffix.vue?vue&type=template&id=98c548c2"
import script from "./NInputSuffix.vue?vue&type=script&lang=js"
export * from "./NInputSuffix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports